/**
 * @desc directive that checks whether # of selected options >= 1
 */

(function() {
	'use strict';

	angular
		.module('app.supplyChain')
		.directive('uiSelectMultiRequired', uiSelectMultiRequired);

	function uiSelectMultiRequired() {
		var directive = {
			require: 'ngModel',
			link: link
		};
		return directive;

		function link($scope, $element, $attrs, ctrl) {
			var validate = function(options) {
				var isValid = (options && options.length >= 1);
				ctrl.$setValidity('ui-select-multi-required', isValid);
				return options;
			};

			ctrl.$parsers.unshift(validate);
			ctrl.$formatters.push(validate);

			$attrs.$observe('uiSelectMultiRequired', function() {
				return validate(ctrl.$viewValue);
			});
		}
	}
})();
